/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// Transfert INSEE des bulletins PACS (API état civil, préfixe /insee/pacs).
const baseUrlApiInseePacs = '/api/administres/etat-civil/insee/pacs';

/** Aperçu du prochain lot (GET) et envoi sur le SDFI (POST) */
export const getInseePacsLot = () => `${baseUrlApiInseePacs}/lot`;

/** Historique des lots transmis */
export const getInseePacsTransferts = () => `${baseUrlApiInseePacs}/transferts`;

/** Lot transmis : suppression = dévalidation (DELETE) */
export const getInseePacsTransfert = (identifiant: string | number) =>
  `${baseUrlApiInseePacs}/transferts/${identifiant}`;

/** XML archivé d'un lot */
export const getInseePacsTransfertXml = (identifiant: string | number) =>
  `${baseUrlApiInseePacs}/transferts/${identifiant}/xml`;

/** Relance automatique des lots sans accusé de réception à J+1 (POST) */
export const getInseePacsRelances = () => `${baseUrlApiInseePacs}/relances`;

/** Purge à 183 jours des compléments INSEE transmis et des lots archivés (POST) */
export const getInseePacsPurge = () => `${baseUrlApiInseePacs}/purge`;

/** Paramétrage du transfert INSEE de l'entité (GET lecture, PUT enregistrement) */
export const getInseeParametrage = () =>
  '/api/administres/etat-civil/insee/parametrage';
